
export default {
  methods: {
    ruDateFormat (dateString, isOnlyDateNoTime = false, withSeconds = false) {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };

      if (!isOnlyDateNoTime) {
        options.hour = 'numeric';
        options.minute = 'numeric';
        if (withSeconds) {
          options.second = 'numeric';
        }
      }

      return date.toLocaleDateString('ru-RU', options);
    },
  },
};
